import {getBalanceString} from "./Utils";

export function updateSchemeDetails(containerId: string) {
    const container = document.getElementById(containerId)!;
    const isYearly = (container.querySelector(".option-yearly") as HTMLOptionElement)!.selected;

    const startDate = (container.querySelector(".input-startdate") as HTMLInputElement)!.valueAsDate;
    const initialConsumption = (container.querySelector(".input-initialconsumption") as HTMLInputElement)!.valueAsNumber;
    const allowanceHours = (container.querySelector(".input-allowance") as HTMLInputElement)!.valueAsNumber;

    const invalidInput = !startDate || isNaN(initialConsumption) || isNaN(allowanceHours) || initialConsumption < 0 || allowanceHours < 1
    container.querySelector(".table-accounting")!.classList.toggle("d-none", invalidInput);
    if (invalidInput) {
        return;
    }

    let firstPeriodAccrual = Math.round(allowanceHours * 60);
    if (isYearly) {
        firstPeriodAccrual = scaleAccrualForDayOfYear(startDate, firstPeriodAccrual);
    }
    (container.querySelector(".td-title") as HTMLTableCellElement)!.innerText = isYearly ? "Første år" : "Første måned";
    (container.querySelector(".td-accrual") as HTMLTableCellElement)!.innerText = getBalanceString(firstPeriodAccrual);
    (container.querySelector(".td-initialconsumption") as HTMLTableCellElement)!.innerText = getBalanceString(initialConsumption * 60);
    (container.querySelector(".td-available") as HTMLTableCellElement)!.innerText = getBalanceString(firstPeriodAccrual - initialConsumption * 60);
}

function scaleAccrualForDayOfYear(startDate: Date, yearlyAllowanceMinutes: number) {
    const numerator = getDayOfYear(startDate) - 1;
    const denominator = getDayOfYear(new Date(startDate.getFullYear(), 11, 31));
    const fraction = 1.0 - (numerator - 1.0) / denominator;
    const precisionMinutes = 15;

    return Math.round(Math.round(yearlyAllowanceMinutes * fraction / precisionMinutes) * precisionMinutes);
}

function getDayOfYear(date: Date) {
    const startOfYear = new Date(date.getFullYear(), 0, 1);
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const differenceInMilliseconds = date.getTime() - startOfYear.getTime();

    return Math.ceil(differenceInMilliseconds / millisecondsPerDay) + 1;
}